import { Component } from '@angular/core';

@Component({
    selector: 'app-left-popover',
    templateUrl: './left-popover.component.html',
    styleUrls: ['./left-popover.component.scss'],
})
export class LeftPopoverComponent {}
